import { /* baseClient, */ authClient, API } from '../../utils/index';

export function getBuoysByRegatta(id) {
	return authClient().get(`${API}/buoy/by-regatta/${id}`);
}

// Create buoy
export const postBuoy = async (buoy) => {
	return authClient().post(`${API}/buoy`, buoy);
};

export const putBuoy = (id, buoy) => {
	return authClient().put(`${API}/buoy/${id}`, buoy);
};


// Delete buoy
export const deleteBuoy = (id) => {
  return authClient().delete(`${API}/buoy/${id}`)
}